import { useNgSession } from "@sazka/ng/ng-session";
import {
    MessageInitDto,
    MessageStartDto,
    WindowMessage,
} from "@sazka/websocket/notifications/models/window-message-dto";
import { logException } from "@sazka/utils/logger/use-app-logger";

const { session } = useNgSession();

export const sendInitMessage = (comunicationSource: WindowCommunicationSource) => {
    try {
        comunicationSource.postMessage({
            name: "init",
            data: {
                baseUrl: appSettings["Integrations:NotificationsServer:Domain"],
                environment: environment.env,
                appInsightsKey: appSettings["ApplicationInsights:InstrumentationKey"],
            },
        } as WindowMessage<MessageInitDto>);
    } catch (err) {
        logException("notifications-window", err, {
            message: "Send-init error",
        });
    }
};

export const sendStartMessage = (comunicationSource: WindowCommunicationSource, isLiveDealer: boolean) => {
    try {
        comunicationSource.postMessage({
            name: isLiveDealer ? "startLiveDealer" : "start",
            data: {
                playerId: session.value.PlayerID,
                sessionToken: session.value.SessionToken,
            },
        } as WindowMessage<MessageStartDto>);
    } catch (err) {
        logException("notifications-window", err, {
            message: "Send-start error",
        });
    }
};

export const sendStopMessage = (comunicationSource: WindowCommunicationSource) => {
    try {
        comunicationSource.postMessage({
            name: "stop",
        } as WindowMessage<null>);
    } catch (err) {
        logException("notifications-window", err, {
            message: "Send-stop error",
        });
    }
};
